import { Customer as CustomerModel } from 'model/Customer';
import { Address } from 'model/Location';
import { Quote } from 'model/Quote';
import { Vehicle as VehicleModel } from 'model/Vehicle';

export enum PaymentStatus {
  NEW = 'NEW',
  PROCESSING = 'PROCESSING',
  SUCCEEDED = 'SUCCEEDED',
  FAILED = 'FAILED',
  ERROR = 'ERROR',
  CANCELED = 'CANCELED'
}

export enum OrderStatus {
  NEW = 'NEW',
  PROCESSING = 'PROCESSING',
  SUCCEEDED = 'SUCCEEDED',
  FAILED = 'FAILED'
}

export interface SessionState {
  quoteForm: boolean;
  quoteAccepted: boolean;
  customerAndVehicle: boolean;
  pickup: boolean;
  delivery: boolean;
  payment: boolean;
  completed: boolean;
  paymentSucceeded: boolean;
  orderSucceeded: boolean;
}

interface GetOrderPriceProps {
  quote?: Quote,
  numberOfVehicles?: number;
  enclosed: boolean;
  vehicles?: Partial<VehicleModel>[];
}

export const formatPhoneNumber = (value: string) => {
  if (!value) return value;
  if (value.length <= 3) return value;
  if (value.length <= 7) {
    return `(${value.substring(0, 3)}) ${value.substring(3, 7)}`;
  }
  return `(${value.substring(0, 3)}) ${value.substring(3, 6)}-${value.substring(6, 10)}`;
};

export const mapCustomerToPardotContact = (customer: Partial<CustomerModel>) => ({
  first_name: customer.firstName,
  last_name: customer.lastName,
  email: customer.emailAddress,
  phone: customer.phoneNumber,
  sms_opted_in: customer.optIn || false,
});

export const mapVehiclesToPardotVehicles = (vehicles: Partial<VehicleModel>[]) => vehicles.map(vehicle => ({
  vin: vehicle.vin,
  make: vehicle.make,
  model: vehicle.model,
  year: vehicle.year,
  is_operational: vehicle.operational || false,
}));

export const mapAddressToPardotLocation = (address: Partial<Address>, locationType: string) => ({
  address1: address.address1,
  address2: address.address2 || '',
  city: address.city,
  state: address.state,
  zip: address.zipCode,
  location_type: locationType,
});

export const getOrderPrice = ({ quote, numberOfVehicles, enclosed, vehicles = [] }: GetOrderPriceProps) => {
  const rate = (quote?.rate || vehicles[0].price || 0);
  let finalPrice = rate * (numberOfVehicles || vehicles.length || 0);

  if (vehicles.length) {
    finalPrice = vehicles.reduce((currPrice, vehicle) => {
      let vehiclePrice = rate;

      if (!vehicle.operational) {
        vehiclePrice += quote?.inopFee || 0;
      }

      if (enclosed) {
        vehiclePrice += quote?.enclosedFee || 0;
      }

      return currPrice + vehiclePrice;
    }, 0);
  }

  return finalPrice;
};
